var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form-label", {
    attrs: {
      label: _vm.label,
      "class-name": _vm.formLabelClassName,
      "form-class-name": _vm.formClassName,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "label",
          fn: function () {
            return [_vm._t("label")]
          },
          proxy: true,
        },
        {
          key: "header",
          fn: function () {
            return [_vm._t("header")]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [
              _c(
                "fieldset",
                [
                  _vm._l(_vm.options, function (option, i) {
                    return [
                      _c(
                        "label",
                        {
                          key: _vm.optionKeyLabel + "-" + i,
                          staticClass: "pega-badge-radio pega-mr-5",
                          class: _vm.labelClassName,
                        },
                        [
                          _c("input", {
                            class: _vm.className,
                            attrs: {
                              "data-test": _vm.optionKeyLabel + "-option-" + i,
                              type: _vm.type,
                              disabled: _vm.disabled,
                            },
                            domProps: {
                              value: option.id,
                              checked: _vm.value === option.id,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changeValue($event.target._value)
                              },
                            },
                          }),
                          _c(
                            "span",
                            {
                              class: _vm.valueClassName,
                              attrs: {
                                "data-test":
                                  _vm.optionKeyLabel + "-option-label-" + i,
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(option.name) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  }),
                  _vm._v(" "),
                  _vm._t("suffix"),
                  _vm._v(" "),
                  _vm.validation.isShow
                    ? _c("validation-label", {
                        attrs: { label: _vm.validation.message },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "pega-mt-05" }, [
                    _c("span", [
                      _vm._v("備考"),
                      _c(
                        "small",
                        {
                          staticClass: "pega-ml-1",
                          attrs: { "data-test": "count" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.remarks ? _vm.remarks.length : 0) +
                              "文字/ " +
                              _vm._s(_vm.maxCharacter) +
                              "文字"
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    staticClass:
                      "pega-form-item pega-textarea-low pega-textarea-vertical",
                    class: _vm.className,
                    attrs: {
                      placeholder: _vm.placeholder,
                      "data-test": "item",
                    },
                    domProps: { value: _vm.remarks },
                    on: {
                      input: function ($event) {
                        return _vm.$emit("update:remarks", $event.target.value)
                      },
                    },
                  }),
                ],
                2
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "error",
          fn: function () {
            return [_vm._t("error")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }